// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3057":"b21696200e89e85f","5491":"c3b9cc4cf529d925"}[chunkId] + ".css";
};